module.exports = __webpack_public_path__ + "static/media/loader.fa74628a.gif";